import _ from 'lodash';
import { gettext } from '@eventbrite/i18n';
import { START_LOAD_RESOURCE } from './actionTypes';
import { resourceLoadFailure, resourceLoadSuccess } from './actions';
import { isResourceInProgress, isResourceValid } from './resource';

const handleResourceLoadStart = (store, action) => {
    const { dispatch } = store;
    const state = store.getState();
    const {
        cacheId,
        resourceId,
        getResourcePromise,
        resolve,
        reject,
        testValidity,
    } = action;
    const cache = state[cacheId];
    const resource = cache[resourceId];

    if (isResourceInProgress(resource)) {
        setTimeout(() => handleResourceLoadStart(store, action), 10);
        return;
    }
    if (isResourceValid(resource, testValidity)) {
        _.defer(() => {
            dispatch(
                resourceLoadSuccess(cacheId, resourceId, resource.payload),
            );
            resolve(resource.payload);
        });
        return;
    }
    _.defer(() =>
        getResourcePromise()
            .then((payload) => {
                dispatch(resourceLoadSuccess(cacheId, resourceId, payload));
                resolve(payload);
            })
            .catch((error) => {
                const message = error.message || error;

                dispatch(
                    resourceLoadFailure(
                        cacheId,
                        resourceId,
                        gettext(
                            'There was a problem retrieving this resource: %(message)s',
                            { message },
                        ),
                        error,
                    ),
                );
                reject(error);
            }),
    );
};

const middleware = (store) => (next) => (action) => {
    if (action.type === START_LOAD_RESOURCE) {
        handleResourceLoadStart(store, action);
    }
    return next(action);
};

export default middleware;
